export var TEXT_BOLD = {
  fontFamily: "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Arial, sans-serif",
  fontWeight: '700'
};
export var TEXT_MEDIUM = {
  fontFamily: "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Arial, sans-serif",
  fontWeight: '500'
};
export var TEXT_REGULAR = {
  fontFamily: "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Arial, sans-serif",
  fontWeight: '400'
};
export var MONO_REGULAR = {
  fontFamily: 'monospace',
  fontWeight: '400'
};
//# sourceMappingURL=fonts.js.map